// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VqY6","label":"styles_label__2vyc8"};